import React, { useState } from "react";

import { Error } from "icons";
import PropTypes from "prop-types";

import archivalDataApi from "apis/archivalData";
import {
  Button,
  FileUploader,
  Pane,
  Typography,
} from "clearsense-ui/components";

const UploadPane = ({ isOpen, onClose }) => {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [files, setFiles] = useState();
  const [error, setError] = useState(false);

  const handleFilesLoaded = files => {
    setFiles(files);
    setError(false);
  };

  const handleFilesUpload = async () => {
    if (!files) {
      setError(true);
      return;
    }

    setError(false);
    try {
      setIsButtonLoading(true);
      await archivalDataApi.create({ files });
      setTimeout(() => window.location.reload(), 5000);
      onClose();
    } catch (error) {
      logger.error(error);
    } finally {
      setIsButtonLoading(false);
    }
  };

  return (
    <Pane isOpen={isOpen} onClose={onClose}>
      <Pane.Header>
        <Typography style="h3" type="bold">
          File Upload
        </Typography>
        <Typography>
          Pick your file with a file browser or drop the file here
        </Typography>
      </Pane.Header>
      <Pane.Body className="mt-8">
        <FileUploader
          className="w-full"
          onUploadFinish={handleFilesLoaded}
          setIsButtonLoading={setIsButtonLoading}
        />
        {error && (
          <div className="flex items-center gap-1 mt-1 text-sm text-danger">
            <Error size={15} />
            Please upload file(s)
          </div>
        )}
      </Pane.Body>
      <Pane.Footer>
        <Button
          label="Submit"
          loading={isButtonLoading}
          disabled={isButtonLoading}
          onClick={handleFilesUpload}
          data-cy="upload-file-submit-button"
        />
        <Button
          style="text"
          label="Cancel"
          onClick={onClose}
          data-cy="upload-pane-cancel-button"
        />
      </Pane.Footer>
    </Pane>
  );
};

UploadPane.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default UploadPane;
